import {useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import {motion} from "framer-motion";

const Modal = ({modalTitle = false, children, onClose = null}) => {

    const modalRef = useRef(null);
    const {t} = useTranslation();

    useEffect(() => {
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalRef, onClose])

    // noinspection AllyJsxHardcodedStringInspection
    return (
        <motion.div  initial={{opacity: 0}} animate={{opacity: 1}} transition={{duration: 0.25}}
            className="fixed z-20 left-0 right-0 top-0 bottom-0 outline-none overflow-x-hidden overflow-y-auto">
            <div className="relative w-auto pointer-events-none px-6" style={{paddingTop: "5.5rem"}}>
                <div
                    ref={modalRef}
                    className="border-none shadow-2xl relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-xl outline-none text-current">
                    <div
                        className="flex flex-shrink-0 items-center justify-between p-4 border-b-2 border-gray-200 rounded-t-md">
                        <h5 className="text-xl font-medium leading-no   rmal text-gray-800">
                            {modalTitle}
                        </h5>
                        <button type={"button"}
                                className={"font-bold absolute top-2 right-3 shadow-2xl rounded-full w-6 h-6 bg-gray-200"}
                                onClick={() => {
                                    onClose();
                                }}>X
                        </button>
                    </div>
                    <div className="relative p-4 overflow-scroll" style={{maxHeight: "55vh"}}>
                        {children}
                    </div>
                    <div
                        className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t-2 border-gray-200 rounded-b-md">
                        <button
                            type="button"
                            onClick={onClose}
                            className="inline-block px-6 py-2.5 bg-red-600 text-white font-medium text-xs leading-tight rounded shadow-md">
                            {t('modal.annuler')}
                        </button>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default Modal;